import { render, staticRenderFns } from "./ForRent.vue?vue&type=template&id=9589391c&"
import script from "./ForRent.vue?vue&type=script&lang=js&"
export * from "./ForRent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports